module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image47.77d976ba.jpg";